<template>
<div>

    <div v-if="allowContent">
        <!-- @slot Default slot is optional -->
        <slot></slot>
    </div>

    <div v-else>
        <!-- @slot If the user is not logged in "Login" button shown there   -->
        <slot name="not-logged-in"></slot>
    </div>

    <div v-if="debug" style="margin-top:40px;">

        <v-switch label="pause" v-model="pause" />
        <v-btn @click="refreshToken">Refresh Token</v-btn>

        <h1>OAUTHWrapper</h1>

        <!-- <v-btn color="primary" @click="startLoginFlow">Start Login Flow</v-btn> -->

        <!-- <slot name="start-login-flow" v-on="startLoginFlow">
            
        </slot> -->
        <ul>
            <li>
                <b>autologin</b>:<br />
                <code>{{autologin}}</code>
            </li>
            <li>
                <b>loginUrl</b>:<br />
                <code>{{loginUrl}}</code>
            </li>
            <li>
                <b>querystring</b>:<br />
                <code>{{querystring}}</code>
            </li>
            <li>
                <b>credentials</b>:<br />
                <code>{{credentials}}</code>
            </li>
            <li>
                <b>internalCredentials</b>:<br />
                <code>{{internalCredentials}}</code>
            </li>
            <li>
                <b>allowContent</b>:<br />
                <code>{{allowContent}}</code>
            </li>
            <hr />
            <li>
                <b>validTokenPerc</b>:<br />
                <code>{{validTokenPerc}} %</code>
            </li>
            <li>
                <b>msUntilRefresh</b>:<br />
                <code>{{msUntilRefresh}}</code>
                <v-btn @click="expireCredentials">Expire Credentials</v-btn>
            </li>
            <li>
                <b>expiresOn</b>:<br />
                <code>{{expiresOn}}</code>
            </li>
            <li>
                <b>currentTime</b>:<br />
                <code>{{currentTime}}</code>
            </li>
  
        </ul>
    </div>

    <oauth-response @credentials-new="credentialsNew" :credentials="internalCredentials" @update:credentials="internalCredentials = $event" :autologin="autologin" :debug="debug" />

    <div v-if="debug">
        <button @click="refreshToken">Refresh Token</button>
        <ul>
            <li>
                <b>refreshTokenOptions</b>:<br />
                <code>{{refreshTokenOptions}}</code>
            </li>
            <li>
                <b>credentials</b>:<br />
                <code>{{credentials}}</code>
            </li>
        </ul>
    </div>

</div>
</template>

<script>
import oauthResponse from "./oauth-response"
import oauthMixin from "./oauth-mixin"

export default {
    name: 'OAUTHWrapper',
    mixins: [oauthMixin],
    components: {
        oauthResponse
    },
    created() {
        if (!!this.credentials) {
            this.startRefreshTimer();
        }
    },
    mounted() {
        if (!this.credentials && !this.hasOauthResponse && this.autologin) {
            this.startLoginFlow();
        }
    },
    watch: {
        
        credentialsSubscription(newVal) {
        },

        loginIncrementor(newVal)
        {
            if (!this.credentials && !this.hasOauthResponse) {
                this.startLoginFlow();
            }
        }

    },
    computed: {
        credentialsSubscription() {
            return Object.assign(this.credentials || {}, {
                "subscription": true
            });
        }

    },
    methods: {
        credentialsNew(args) {
            /**
             *  When user details are generated at first it will store in this credentials
             */
            this.$emit('credentials-new', args)
            var route = args.path.split("#")[1];
            this.$router.push(route);
        },
        startLoginFlow() {
            var state = {
                state: this.state,
                path: document.location.href,
                client_id: this.client_id,
                token_uri: this.tokenUrl,
                code_verifier: this.code_verifier,
                client_secret: null,
                type: 'pkce',
                scope: this.scope,
                redirect_uri: this.redirect_uri,
                logout_url: this.logoutUrl
            };
            window.localStorage.setItem(this.state, JSON.stringify(state));
            window.document.location.href = this.loginUrl;
        },
    }

}
</script>
